import { createRoot } from 'react-dom/client'
import { MainBanner } from './MainBanner'

const root = document.getElementById('nova-react-main-banner')

if (root && !root.__novaReactRoot) {
  root.__novaReactRoot = createRoot(root)
  root.__novaReactRoot.render(<MainBanner payload={window.novaThemeMainBanner || {}} />)
}
